import React from "react";

export default function PgRuleAllowed({ PropertyObject }) {

  const [rules, setRules] = React.useState([]);

  React.useEffect(() => {
    const rulesallowed = PropertyObject?._lstPGRuleAllowed || [];
    const itemsPerGroup = Math.ceil(rulesallowed.length / 3);
    const groupedRules = [
      rulesallowed.slice(0, itemsPerGroup),
      rulesallowed.slice(itemsPerGroup, itemsPerGroup * 2),
      rulesallowed.slice(itemsPerGroup * 2)
    ];

    
    setRules(groupedRules);
  }, [PropertyObject]);

  return (
    <>
      {PropertyObject?._lstPGRuleAllowed?.length > 0 && (
        <>
          <h5 className="title fw-6">PG Rules : Allowed</h5>
          <div className="wrap-feature">
            {rules.map((rule, index) => (
              <div className="box-feature" key={index}>
                <ul>
                  {rule.map((item, idx) => (
                    <li className="feature-item" key={idx}>
                      {item.RuleName}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </>
      )}
    </>
  );
}
